const DATA_TEST_IDS = {
  deleteDialog: 'profile-address__fragments_delete-dialog',
} as const;

export default DATA_TEST_IDS;
